{
  "de": {
    "languages": {
      "ar": "Arabisch",
      "cs": "Tschechisch",
      "da": "Dänisch",
      "de": "Deutsch",
      "el": "Griechisch",
      "en": "Englisch",
      "es": "Spanisch",
      "fi": "Finnisch",
      "fr": "Französisch",
      "he": "Hebräisch",
      "hu": "Ungarisch",
      "it": "Italienisch",
      "ja": "Japanisch",
      "ko": "Koreanisch",
      "nl": "Niederländisch",
      "no": "Norwegisch",
      "pl": "Polnisch",
      "pt": "Portugiesisch",
      "ro": "Rumänisch",
      "ru": "Russisch",
      "sk": "Slowakisch",
      "sv": "Schwedisch",
      "th": "Thai",
      "uk": "Ukrainisch",
      "vi": "Vietnamesisch",
      "zh": "Chinesisch"
    }
  }
}
